<template>
  <div>
    <a-table v-if="dataSource.length > 0" size="small" :pagination="false" :columns="columns" :data-source="dataSource" row-key="id">
      <span slot="action" slot-scope="text, record, index">
        <a class="ant-dropdown-link" @click="onRemove(record, index)">移除</a>
      </span>
      <span slot="customerTitle" slot-scope="text, record">
        <a-tooltip placement="top" :title="record.title">
          <a class="custom-link" :href="requirementLink(record)" target="_blank"> {{ record.title }} </a>
        </a-tooltip>
      </span>
      <span slot="type" slot-scope="text, record">
        <a-badge v-if="record.requirement_type" :color="storyTypes[record.requirement_type].color" :text="storyTypes[record.requirement_type].label" />
      </span>
    </a-table>
  </div>
</template>
<script>
import { storyTypes } from '@/utils/dictionary';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 80,
    customRender: (_text, _row) => {
      return 'PR-' + _text;
    }
  },
  {
    title: '标题',
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
    scopedSlots: { customRender: 'customerTitle' }
  },
  {
    title: '类型',
    align: 'center',
    dataIndex: 'type',
    key: 'type',
    width: 120,
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 60,
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  props: {
    dataSource: {
      type: [Array, String],
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      storyTypes,
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  computed: {
    requirementLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:story:detail',
          query: { storyId: record.id }
        });
        return route.href;
      };
    }
  },
  methods: {
    onRemove(record, index) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要移除该需求吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          self.$emit('requirement-change', index);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}

.custom-link:hover {
  color: #1890ff;
}
</style>
